<template>
  <v-container
    fluid
    class="mt-5">
    <v-layout
      wrap
      justify-center>
      <v-flex
        xs12
        sm10
        md8
        lg6
        xl4>
        <v-row
          no-gutters
          justify="center"
          class="text-center">
          <v-col cols="10">
            <v-row
              justify="center"
              align="end">
              <div class="mb-1 text-size-4">
                パートナーにQRコードを<br>
                読み取ってもらってください
              </div>
            </v-row>
          </v-col>
        </v-row>

        <v-row
          no-gutters
          justify="center"
          class="text-center">
          <vue-qrcode
            :value="qr.url"
            :options="qr.options" />
        </v-row>

        <v-row
          no-gutters
          justify="center">
          <v-col
            cols="10"
            class="text-center">
            <div class="text-size-2">
              {{ validDatetime }}
            </div>
          </v-col>

          <v-col
            cols="8"
            class="text-center p-update">
            <v-btn
              color="secondary"
              text
              @click="refreshQR();">
              更新
            </v-btn>
          </v-col>
        </v-row>

        <v-row
          no-gutters
          justify="center"
          class="mt-5">
          <v-row
            no-gutters
            justify="center"
            class="caption">
            <ul>
              <li><strong>{{ $store.state.profile.partnerUpperLimit }}人</strong>と連携することが可能です</li>
              <li>連携後は、<strong>"パートナー切り替え"</strong> から二人の思い出を登録することができます</li>
            </ul>
          </v-row>
        </v-row>

        <v-row
          no-gutters
          justify="center"
          class="mt-7">
          <v-col
            cols="8"
            class="text-center">
            <v-btn
              color="secondary"
              @click="reload();">
              パートナーの読み取り完了
            </v-btn>
          </v-col>
        </v-row>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<style scoped>
#qrGenarate {
  text-align: center;
}
.p-update {
  padding-left: 180px;
}
</style>

<script>
import VueQrcode from '@chenfengyuan/vue-qrcode';
import utils from '../../libs/utils';

const dayjs = require('dayjs');
const jwt = require('jsonwebtoken');

export default {
  components: {
    VueQrcode,
  },
  props: {
    partnerDialog: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      qr: {
        url: null,
        options: {
          color: {
            dark: '#3F51B5',
            light: '#FFFFFF',
          },
        },
      },
      validDatetime: '',
    };
  },
  watch: {
    partnerDialog () {
      if (this.partnerDialog) this.refreshQR();
    },
  },
  mounted: function() {
    this.refreshQR();
  },
  methods: {
    refreshQR: function() {
      const token = jwt.sign(
        {
          lineId: this.$store.state.profile.lineId,
        },
        process.env.VUE_APP_QR_SECRET,
        {
          expiresIn: '60 minutes',
          algorithm: 'HS256',
        },
      );

      const params = token.split('.');
      this.qr.url = `${window.location.origin}/partner/${params[0]}/${params[1]}/${params[2]}`;
      utils.consoleLog(this.qr.url);

      this.validDatetime = `有効期限(60分) : ${dayjs().add('1', 'hour').format('MM/DD HH:mm:ss')}`;
    },
    reload: function() {
      location.reload();
    },
  },
};
</script>
